import { Contract } from "near-api-js";
import { useEffect, useState } from "react";
import useNear from "./nearHook";

const SBT_ENUMERATE_PAGE_SIZE = 10;

const useSbt = () => {
  const near = useNear();

  const getContract = async (contractId) => {
    // debugger;
    const contract = await new Contract(
      near.account.wallet.account(),
      contractId,
      {
        viewMethods: [
          "sbt_token",
          "sbt_metadata",
          "sbt_tokens_for_owner",
          "sbt_supply_for_owner",
        ],
        changeMethods: ["add_consent"],
      }
    );
    return contract;
  };

  const getContractMetadata = async (contractId) => {
    try {
      const contract = await getContract(contractId);
      return await contract.sbt_metadata();
    } catch {
      return null;
    }
  };

  const getSbtTokensForAccount = async (contractId, accountId) => {
    try {
      const contract = await getContract(contractId);
      const supply = await contract.sbt_supply_for_owner({
        account_id: accountId,
      });

      const res = await Promise.all(
        [...Array(Math.ceil(supply / SBT_ENUMERATE_PAGE_SIZE)).keys()].map(
          (i) =>
            contract.sbt_tokens_for_owner({
              account_id: accountId,
              from_index: i * SBT_ENUMERATE_PAGE_SIZE,
              limit: Math.min((i + 1) * SBT_ENUMERATE_PAGE_SIZE, supply),
            })
        )
      );
      return res.flat();
    } catch {
      return [];
    }
  };

  const addConsent = async (contractId, tokenIds) => {
    const tokens = tokenIds.join(",");
    const sig = await near.account.sign(tokens);

    const contract = await getContract(contractId);

    return await contract.add_consent({
      consent: {
        signed_ids: tokens,
        public_key: sig.public_key,
        signature: sig.signature,
      },
    });
  };

  return {
    getContractMetadata,
    getSbtTokensForAccount,
    addConsent,
  };
};

export default useSbt;
